// MVP2-282: Feature lock overlay component
import { Lock } from "lucide-react";
import { useIsDemoUser } from "@/shared/hooks/useIsDemoUser";
import { Button } from "@/shared/ui/button";

interface FeatureLockOverlayProps {
  message?: string;
  title?: string;
}

export function FeatureLockOverlay({
  message = "Please contact a Robotic Imaging representative to unlock this feature.",
  title = "Feature Locked"
}: FeatureLockOverlayProps) {
  const isDemoUser = useIsDemoUser();

  return (
    <div 
      className="absolute inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-[1px]"
      aria-label="Feature locked overlay"
    >
      <div className="flex flex-col items-center justify-center space-y-6 max-w-md px-6 text-center">
        {/* Lock Icon with translucent primary color */}
        <div className="relative">
          <Lock 
            className="h-24 w-24 text-primary opacity-60" 
            strokeWidth={1.5}
          />
        </div>
        
        {/* Title */}
        <h2 className="text-2xl font-semibold text-foreground">
          {title}
        </h2>
        
        {/* Message */}
        <p className="text-base text-muted-foreground leading-relaxed">
          {message}
        </p>
        {isDemoUser && (
          <Button variant="default" size="sm" asChild>
            <a href="https://www.roboticimaging.com/contact" target="_blank" rel="noopener noreferrer">
              Contact Sales
            </a>
          </Button>
        )}
      </div>
    </div>
  );
}
